export const MODULES_ARRAY = [
  {
    label: 'Help',
    key: 'help',
  },
  {
    label: 'Dashboard',
    key: 'dashboard',
  },
  {
    label: 'Widgets',
    key: 'widgets',
  },
  {
    label: 'Map',
    key: 'map',
  },
  {
    label: 'Clients',
    key: 'clients',
  },
  {
    label: 'Items',
    key: 'items',
  },
  {
    label: 'Stores',
    key: 'stores',
  },
  {
    label: 'Warehouse',
    key: 'warehouse',
  },
  {
    label: 'Document Center',
    key: 'document-center',
  },
  {
    label: 'User Management',
    key: 'user-management',
  },
  {
    label: 'Scheduler',
    key: 'scheduler',
  },
  {
    label: 'Calendar',
    key: 'calendar',
  },
  {
    label: 'Quote Template',
    key: 'quote-template',
  },
  {
    label: 'Chargeback',
    key: 'chargeback',
  },
  {
    label: 'Project Management',
    key: 'project-management',
  },
  {
    label: 'Payroll',
    key: 'payroll',
  },
  {
    label: 'Audit Log Reports',
    key: 'audit-log',
  },
  {
    label: 'Payment Request',
    key: 'payment-request',
  },
  {
    label: 'Data Import',
    key: 'data-import',
  },
  {
    label: 'Labor Profiles',
    key: 'labor-profiles',
  },
  {
    label: 'Quote Template',
    key: 'quote-template',
  },
  {
    label: 'Event Logs',
    key: 'event-logs',
  },
  {
    label: 'Configuration',
    key: 'configuration',
  },
  {
    label: 'Checklist',
    key: 'checklist',
  },
  {
    label: 'User Activity',
    key: 'user-activity',
  },
  {
    label: 'Exported Reports',
    key: 'exported-reports',
  },
  {
    label: 'Opportunity',
    key: 'opportunity',
  },
  {
    label: 'Quotes',
    key: 'quotes',
  },
  {
    label: 'Payments Configuration',
    key: 'payments-configuration',
  },
  {
    label: 'Vendor Management',
    key: 'vendor-management',
  },
  {
    label: 'General Purchase Order',
    key: 'general-purchase-order',
  },
  {
    label: 'Tenant Billing',
    key: 'tenant-billing',
  },
  {
    label: 'Configuration',
    key: 'configuration',
  },
  {
    label: 'Bulletin',
    key: 'bulletin',
  },
  {
    label: 'Login Logs',
    key: 'login-logs',
  },
  {
    label: 'Reset Password Logs',
    key: 'reset-password-logs',
  },
  {
    label: 'Customer Login Logs',
    key: 'customer-login-logs',
  },
  {
    label: 'Customer Register Logs',
    key: 'customer-register-logs',
  },
  {
    label: 'Customer Reset Password Logs',
    key: 'customer-reset-password-logs',
  },
  {
    label: 'Availability Updates',
    key: 'availability-updates',
  },
  {
    label: 'Group Items',
    key: 'group-items',
  },
  {
    label: 'Scheduling',
    key: 'reports',
  },
  {
    label: 'Roles Management',
    key: 'roles',
  },
  {
    label: 'Project Items Configuration',
    key: 'project-items-configuration',
  },
  {
    label: 'RO Configuration',
    key: 'ro-configuration',
  },
  {
    label: 'Warranty Configuration',
    key: 'warranty-configuration',
  },
  {
    label: 'CRM Configuration',
    key: 'crm-configuration',
  },
  {
    label: 'Invoice',
    key: 'invoice',
  },
  {
    label: 'Project Layout',
    key: 'dynamic-layout',
  },
  {
    label: 'Brand Logo',
    key: 'brand-logo',
  },
  {
    label: 'Related POs',
    key: 'related-po',
  },
  {
    label: 'Group Source Category',
    key: 'group-source-category',
  },
];

export const MODULES_ARRAY_SORTED = [
  { label: 'Audit Log Reports', key: 'audit-log' },
  { label: 'Availability Updates', key: 'availability-updates' },
  { label: 'Brand Logo', key: 'brand-logo' },
  { label: 'Bulletin', key: 'bulletin' },
  { label: 'Calendar', key: 'calendar' },
  { label: 'Chargeback', key: 'chargeback' },
  { label: 'Checklist', key: 'checklist' },
  { label: 'Clients', key: 'clients' },
  { label: 'Configuration', key: 'configuration' },
  { label: 'CRM Configuration', key: 'crm-configuration' },
  { label: 'Customer Login Logs', key: 'customer-login-logs' },
  { label: 'Customer Register Logs', key: 'customer-register-logs' },
  {
    label: 'Customer Reset Password Logs',
    key: 'customer-reset-password-logs',
  },
  { label: 'Dashboard', key: 'dashboard' },
  { label: 'Data Import', key: 'data-import' },
  { label: 'Document Center', key: 'document-center' },
  { label: 'Event Logs', key: 'event-logs' },
  { label: 'Exported Reports', key: 'exported-reports' },
  { label: 'General Purchase Order', key: 'general-purchase-order' },
  { label: 'Group Items', key: 'group-items' },
  { label: 'Group Source Category', key: 'group-source-category' },
  { label: 'Help', key: 'help' },
  { label: 'Invoice', key: 'invoice' },
  { label: 'Items', key: 'items' },
  { label: 'Labor Profiles', key: 'labor-profiles' },
  { label: 'Login Logs', key: 'login-logs' },
  { label: 'Map', key: 'map' },
  { label: 'Opportunity', key: 'opportunity' },
  { label: 'Payment Request', key: 'payment-request' },
  { label: 'Payments Configuration', key: 'payments-configuration' },
  { label: 'Payroll', key: 'payroll' },
  {
    label: 'Project Items Configuration',
    key: 'project-items-configuration',
  },
  { label: 'Project Layout', key: 'dynamic-layout' },
  { label: 'Project Management', key: 'project-management' },
  { label: 'Quote Template', key: 'quote-template' },
  { label: 'Quotes', key: 'quotes' },
  { label: 'Related POs', key: 'related-po' },
  { label: 'Reset Password Logs', key: 'reset-password-logs' },
  { label: 'RO Configuration', key: 'ro-configuration' },
  { label: 'Roles Management', key: 'roles' },
  { label: 'Scheduler', key: 'scheduler' },
  { label: 'Scheduling', key: 'reports' },
  { label: 'Stores', key: 'stores' },
  { label: 'Tenant Billing', key: 'tenant-billing' },
  { label: 'User Activity', key: 'user-activity' },
  { label: 'User Management', key: 'user-management' },
  { label: 'Vendor Management', key: 'vendor-management' },
  { label: 'Warehouse', key: 'warehouse' },
  { label: 'Warranty Configuration', key: 'warranty-configuration' },
  { label: 'Widgets', key: 'widgets' },
];

export const STATUS_OPTIONS = [
  { label: 'New', value: 'new' },
  { label: 'Enhanced', value: 'enhancement' },
  { label: 'Beta', value: 'beta' },
];

export const TYPES = { GROUP: 3, FEATURE: 2, ONBOARDING: 1 };
